import { TemplateGeneralDto } from "@domain/project/template/property/general/template-general.dto";
import { TemplateProjectDto } from "@domain/project/template/property/project/template-project.dto";
import { Type } from "class-transformer";
import { IsOptional, ValidateNested } from "class-validator";

export class TemplatePropertyDto {
  @IsOptional()
  @ValidateNested()
  @Type(() => TemplateGeneralDto)
  general?: TemplateGeneralDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => TemplateProjectDto)
  project?: TemplateProjectDto;
}
